// Journals.js (remains largely the same as your last provided,
// specifically the Link component part)

import React, { useEffect, useState, useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import { Grid, Typography, Button, CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { Link } from "react-router-dom";
import PageContainer from "../component/PageContainer";
import TablePagination from "@mui/material/TablePagination";
import JournalImg from "../assets/images/jorunal-image.jpg"; // Static image for list view
import CustomPagination from "../component/Pagination";

const Journals = () => {
  const isPhone = useMediaQuery({ query: "(max-width: 812px)" });

  const [journals, setJournals] = useState({
    current_page: 1,
    data: [],
    first_page_url: null,
    from: null,
    last_page: 1,
    last_page_url: null,
    links: [],
    next_page_url: null,
    path: null,
    per_page: 10,
    prev_page_url: null,
    to: null,
    total: 0,
  });
  const [journalLoading, setJournalLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getJournals = useCallback(async () => {
    setJournalLoading(true);
    try {
      const journalres = await axios.get(
        `https://cms.nti.edu.ng/api/journals?page=${
          currentPage
        }&per_page=${rowsPerPage}`
      );
      setJournals(journalres.data);
    } catch (error) {
      console.error("Error fetching journal data:", error);
    } finally {
      setJournalLoading(false);
    }
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    getJournals();
  }, [getJournals]);

  const handleChangePage = (event, newPage) => {
    console.log("Page changed to:", newPage);
    if (newPage === currentPage) return;
    setCurrentPage(Math.abs(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {
    getJournals();
  }, [currentPage, rowsPerPage, getJournals]);

    // const pageCount = Math.ceil(totalResults / rowsPerPage);

  
    const startIndex = (currentPage - 1) * rowsPerPage + 1;
    const endIndex = Math.min(currentPage * rowsPerPage);

  return (
    <PageContainer>
      <Helmet>
        <title>Journals | National Teachers' Institute Kaduna</title>
      </Helmet>

      <div className="journal-container">
        {journalLoading ? (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ height: "200px" }}
          >
            <CircularProgress sx={{ color: "#46C35F" }} />
            <Typography variant="body1" style={{ marginLeft: "10px" }}>
              Loading Journals...
            </Typography>
          </Grid>
        ) : (
          <Grid
            container
            style={{ padding: isPhone ? "0 16px" : "0 92px" }}
            spacing={4}
          >
            {journals.data.length > 0 ? (
              <>
                {journals.data.map((journal) => (
                  <Grid item xs={12} key={journal.id}>
                    <Grid
                      container
                      spacing={isPhone ? 2 : 4}
                      alignItems="flex-start"
                    >
                      <Grid
                        item
                        xs={12}
                        md={4}
                        className="journal-image-container"
                      >
                        <img
                          src={JournalImg} // This is a static image for the list view
                          alt={journal.title}
                          className="journal-image"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: "8px",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={8}
                        className="journal-body-content"
                      >
                        <Typography variant="h6" component="h3" gutterBottom>
                          {journal.title}
                        </Typography>
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          style={{ marginBottom: "20px" }}
                        >
                          {journal.description}
                        </Typography>

                        <Button
                          component={Link}
                          to={{
                            pathname: `/journal/${journal.id}`,
                            state: {
                              journalTitle: journal.title,
                              journalDescription: journal.description,
                            },
                          }}
                          size="medium"
                          sx={{
                            textTransform: "none",
                            backgroundColor: "#46C35F",
                            color: "#fff",
                            "&:hover": { backgroundColor: "#3a9e4b" },
                          }}
                        >
                          View Journal
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <CustomPagination
                    count={journals.last_page}
                    page={journals.current_page - 1}
                    onPageChange={handleChangePage}
                    rowsPerPage={journals.per_page}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <Typography variant="body1" color="text.secondary">
                  No journals found.
                </Typography>
              </Grid>
            )}
          </Grid>
        )}
      </div>
    </PageContainer>
  );
};

export default Journals;
